<div class="w-full bg-white/70 border border-gray-200 rounded-2xl p-4 shadow-sm mt-3">
  <div class="flex items-center justify-between mb-2">
    <label class="text-xs font-medium text-gray-600">{{ name() }}</label>
    @if (!readOnly()) {
      <button
          type="button"
          (click)="openCreateDocumentModal()"
          class="text-xs text-blue-600 hover:text-blue-800 transition-colors inline-flex items-center gap-1 font-medium"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
          <path
              d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"/>
        </svg>
        <span>Toevoegen</span>
      </button>
    }
  </div>

  <div class="flex flex-col gap-2">
    @for (d of documents(); track $index) {
      <div class="flex gap-2 items-center">
        <div class="relative flex-grow">
          <div class="font-medium flex gap-5 items-center">
            {{ d.document.name }}

            <div class="text-xs text-gray-500 mt-0.5">
              Verloopt: {{ d.document.expirationDate | date:'dd/MM/yyyy' }}
            </div>
          </div>
        </div>

        @if (!readOnly()) {
          <div>
            <button
                type="button"
                (click)="downloadDocument(d)"
                class="p-2 text-gray-400 hover:text-red-600 transition-colors"
                title="Verwijderen"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"/>
              </svg>

            </button>

            <button
                type="button"
                (click)="openDocumentModal(d)"
                class="p-2 text-gray-400 hover:text-gray-600 transition-colors"
                title="Verwijderen"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-5">
                <path
                    d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32L19.513 8.2Z"/>
              </svg>
            </button>

            <button
                type="button"
                (click)="removeDocument($index)"
                class="p-2 text-gray-400 hover:text-red-600 transition-colors"
                title="Verwijderen"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-5">
                <path fill-rule="evenodd"
                      d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
                      clip-rule="evenodd"/>
              </svg>
            </button>
          </div>
        }
      </div>
    }

    @if (documents().length === 0) {
      <div
          class="text-xs text-gray-400 italic p-4 border border-dashed border-gray-200 rounded-xl text-center bg-gray-50/50">
        Geen items toegevoegd. Klik op 'Toevoegen' om te beginnen.
      </div>
    }
  </div>
</div>
@if (showDocumentModal) {
  <div
      class="fixed inset-0 z-40 flex items-center justify-center px-3 sm:px-3"
      role="dialog"
      aria-modal="true"
      aria-labelledby="sector-drawer-title"
      (click)="closeDocumentModal()"
  >
    <div
        class="absolute inset-0 bg-gray-700/75 backdrop-blur-sm transition-opacity duration-300 ease-in-out"
    ></div>

    <div
        class="relative w-full max-w-2xl sm:max-w-3xl transform overflow-hidden rounded-2xl bg-white shadow-2xl transition-all"
        (click)="$event.stopPropagation()"
    >
      <div
          class="flex items-center justify-between border-b border-gray-100 px-5 md:px-6 py-4 md:py-5"
      >
        <h2
            id="sector-drawer-title"
            class="text-base md:text-lg font-semibold text-gray-900"
        >
          {{ editingDocument ? 'Bewerk document' : 'Nieuw document toevoegen' }}
        </h2>

        <button
            type="button"
            class="cursor-pointer inline-flex items-center justify-center rounded-md p-2 md:p-2.5 text-gray-600 hover:text-gray-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            (click)="closeDocumentModal()"
        >
          <span class="sr-only">Close panel</span>
          <ion-icon
              name="close-outline"
              class="text-xl"
              aria-hidden="true"
          ></ion-icon>
        </button>
      </div>

      <div class="max-h-fit overflow-y-auto px-5 md:px-6 py-6 md:py-7">
        <lib-input-wrapper [parentFormGroup]="formGroup()"
                           [inputSchema]="documentSchema"
                           (filePush)="handleFilePush($event)">
        </lib-input-wrapper>
        <lib-button
            [button]="submitButton"
            (click)="saveDocument()"
        ></lib-button>
      </div>
    </div>
  </div>
}
